/**
 * A named element — the only property `hasDuplicateElementName` needs.
 */
export interface NamedElement {
  readonly name: string;
}

/**
 * Check if the given list of elements has another element with the same name as
 * the given element.
 */
export function hasDuplicateElementName<T extends NamedElement>(
  list: readonly T[],
  element: T
): boolean {
  return list.filter( // filter out the element
    (e) => e !== element
  ).map( // map to lowercase names
    (e) => e.name.toLowerCase()
  ).includes(element.name.toLowerCase())
}
